module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGBAMAAAAI3hL1AAAAKlBMVEUAAAC1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbW1tbUrO9GOAAAADXRSTlMAuhbn39Ssm4okDDc23A4kSgAAACtJREFUCNdjOKjAwCTNIBvEoHqRYeGVmb5SDAy5xtcYGBjY7xYwAEEHAwMAnooIK1BfNb4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xzxl.png
// module id = NP3m
// module chunks = 1